import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'analyst'

const AnalystModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default AnalystModule



// WEBPACK FOOTER //
// ./src/store/module/analyst/index.js